(() => {
  let inFlight = false;

  document.addEventListener("input", (e) => {
    if (e.target.id !== "cart-discount-input") return;
    const message = document.getElementById("discount-msg");
    if (message) {
      message.className = "discount-msg";
      message.textContent = "";
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.target.id !== "cart-discount-input") return;
    const button = document.getElementById("cart-discount-btn");
    if (e.key === "Enter" && button && !button.disabled) {
      e.preventDefault();
      applyDiscount();
    }
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest("#cart-discount-btn")) return;
    applyDiscount();
  });

  async function applyDiscount() {
    if (inFlight) return;

    const input = document.getElementById("cart-discount-input");
    const button = document.getElementById("cart-discount-btn");
    const message = document.getElementById("discount-msg");
    if (!input || !button || !message) return;

    const code = input.value.trim();
    if (!code) return;

    inFlight = true;
    button.disabled = true;
    button.innerHTML = '<span class="discount-spinner"></span>';
    message.className = "discount-msg";
    message.textContent = "";

    try {
      await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
        credentials: "same-origin"
      });

      const cart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());

      const sections = await fetch("/?sections=cart-drawer", {
        credentials: "same-origin"
      }).then(r => r.json());

      const parser = new DOMParser();
      const doc = parser.parseFromString(sections["cart-drawer"], "text/html");
      const newDrawer = doc.querySelector("#CartDrawer");
      const currentDrawer = document.querySelector("#CartDrawer");

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      const freshMessage = document.getElementById("discount-msg");
      if (freshMessage) {
        freshMessage.className = "discount-msg success";
        freshMessage.textContent = "Discount code submitted. It will be validated at checkout.";
      }

      document.dispatchEvent(new CustomEvent("cart:discount-applied", { detail: cart }));

    } catch (err) {
      console.error(err);
      const freshMessage = document.getElementById("discount-msg");
      if (freshMessage) {
        freshMessage.className = "discount-msg error";
        freshMessage.textContent = "Something went wrong. Please try again.";
      }
    } finally {
      inFlight = false;
      const freshButton = document.getElementById("cart-discount-btn");
      if (freshButton) {
        freshButton.disabled = false;
        freshButton.innerHTML = "Apply";
      }
    }
  }
})();